module.exports = require('./lib/index.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-csv/index.js
// module id = 2797
// module chunks = 0